import { Receipt } from '../../../types/receipts';
import { Actions, ActionTypes, FetchReceiptsResponse, GetReceipts, GetReceiptsReason } from './actions';
import { paramsEqual } from '../../../helpers/urlParams';

export interface State {
    isLoading: boolean;
    limit: number;
    receipts: Receipt[];
    hasNext: boolean;
    isLoadingNext: boolean;
    accountId: string;
    id: string;
    params: URLSearchParams;
    requestId: number;
    starting_after: string;
}

export const initialState: State = {
    isLoading: false,
    limit: 100,
    receipts: [],
    hasNext: true,
    isLoadingNext: false,
    accountId: '',
    id: '',
    params: new URLSearchParams(),
    requestId: 0,
    starting_after: '',
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetReceipts:
            const clearList = shouldClearList(action, state);
            return {
                ...state,
                isLoading: true,
                receipts: clearList ? [] : state.receipts,
                accountId: action.payload.accountId,
                id: action.payload.id,
                params: action.payload.params,
                requestId: action.payload.requestId,
            };

        case ActionTypes.FetchReceiptsResponse:
            if (action.meta.cause.payload.requestId !== state.requestId) {
                return state;
            }
            return {
                ...state,
                isLoading: false,
                receipts: mergeReceiptsList(action, state),
                starting_after: action.payload.starting_after,
            };

        case ActionTypes.FetchNextResponse:
            return {
                ...state,
                hasNext: action.payload.receipts.length > 0,
                isLoadingNext: false,
                starting_after: state.starting_after,
            };

        default:
            return state;
    }
}

const shouldClearList = (action: GetReceipts, state: State) => {
    if (action.payload.accountId !== state.accountId || action.payload.id !== state.id) {
        return true;
    }
    if (action.payload.reason === GetReceiptsReason.update) {
        return true;
    }
    const blacklist = ['starting_after', 'limit'];
    return !paramsEqual(action.payload.params, state.params, blacklist);
};

const mergeReceiptsList = (action: FetchReceiptsResponse, state: State): Receipt[] => {
    // sanity check, should clear list
    if (shouldClearList(action.meta.cause, state)) {
        return action.payload.receipts;
    }

    const result = [...state.receipts];

    // iterate customers from actions
    const receiptsToAdd: Receipt[] = [];
    action.payload.receipts.forEach(t => {
        const idx = result.findIndex(r => r.id === t.id);
        if (idx > -1) {
            result.splice(idx, 1, t);
        } else {
            receiptsToAdd.push(t);
        }
    });

    const insertAt = result.length + 1;
    result.splice(insertAt, 0, ...receiptsToAdd);
    return result;
};
